import { ZoomIn, ZoomOut, Maximize2, RotateCcw, Filter } from "lucide-react";
import { cn } from "@asm/ui";

interface GraphControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFitView: () => void;
  onReset: () => void;
  showFilters: boolean;
  onToggleFilters: () => void;
}

export function GraphControls({
  onZoomIn,
  onZoomOut,
  onFitView,
  onReset,
  showFilters,
  onToggleFilters,
}: GraphControlsProps) {
  const buttonClass = cn(
    "p-2 bg-card hover:bg-muted border border-border rounded-md transition-colors",
    "focus:outline-none focus:ring-2 focus:ring-primary/50"
  );

  return (
    <div className="absolute left-4 top-4 flex flex-col gap-1 z-10">
      <button
        onClick={onZoomIn}
        className={buttonClass}
        title="Zoom In"
      >
        <ZoomIn className="h-4 w-4" />
      </button>
      <button
        onClick={onZoomOut}
        className={buttonClass}
        title="Zoom Out"
      >
        <ZoomOut className="h-4 w-4" />
      </button>
      <button
        onClick={onFitView}
        className={buttonClass}
        title="Fit to View"
      >
        <Maximize2 className="h-4 w-4" />
      </button>
      <button
        onClick={onReset}
        className={buttonClass}
        title="Reset View"
      >
        <RotateCcw className="h-4 w-4" />
      </button>
      <div className="border-t border-border my-1" />
      <button
        onClick={onToggleFilters}
        className={cn(buttonClass, showFilters && "bg-primary/10 border-primary")}
        title="Toggle Filters"
      >
        <Filter className={cn("h-4 w-4", showFilters && "text-primary")} />
      </button>
    </div>
  );
}
